import { Component } from '@angular/core';
import { IntroducerService } from '../introducer.service';
import { Introducer } from '../introducer';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-introducer-edit',
  templateUrl: 'edit.component.html',
})
export class IntroducerEditComponent {
  /**
   * Details of the introducer being edited.
   */
  public introducer: Introducer;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {IntroducerService} introducerService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private introducerService: IntroducerService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.introducerService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadIntroducer(params.id));
  }

  /**
   * Perform the edit action which send the edited introducer to the backend.
   */
  public edit() {
    const editIntroducer = this.introducerService
      .updateIntroducer(this.introducer.id, this.introducer)
      .subscribe(
        (result: Introducer) => {
          this.notificationService.success(
            `Introducer Updated`,
            `The introducer ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.introducer = new Introducer();
          editIntroducer.unsubscribe();
          this.router.navigate(['/introducers']);
        },
        err => {
          this.notificationService.error(
            `Introducer Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/introducers']);
        },
      );
  }

  /**
   * Loads the requested introducer so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadIntroducer(id: string) {
    this.introducerService.findIntroducer(id).subscribe(
      result => {
        this.introducer = result;
      },
      err => {
        this.notificationService.error(
          `Introducer Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/introducers']);
      },
    );
  }
}
